import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

//Import styled components
import {
	Wrapper,
	CheckboxWrapper,
	FormError,
	CheckboxHidden,
	CheckboxStyled
} from './styles';

// Import icons
import { ReactComponent as IconCheck } from 'assets/icons/ic_tick.svg';

function Checkbox({
	type,
	disabled,
	name,
	autoComplete,
	field,
	form: { touched, errors },
	placeholder,
	text,
	onCheck,
	modifiers
}) {
	const [used, setUsed] = useState(false);
	const [checked, setChecked] = useState(false);

	const onChange = () => {
		setUsed(true);
		setChecked((current) => !current);
	};

	useEffect(() => {
		if (!field.value) {
			setChecked(false);
			setUsed(false);
		} else {
			setChecked(field.value);
		}
	}, [field.value]);

	useEffect(() => {
		if (used) onCheck(checked);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [checked]);

	return (
		<Wrapper>
			<CheckboxWrapper modifiers={modifiers}>
				<CheckboxHidden
					{...field}
					onChange={onChange}
					type={type}
					name={name}
					disabled={disabled}
					className={`${
						touched[field.name] && errors[field.name] ? 'errors' : ''
					}`}
					placeholder={placeholder}
					autoComplete={autoComplete}
				/>
				<CheckboxStyled checked={checked} modifiers={modifiers}>
					<IconCheck />
				</CheckboxStyled>
				<p>{text}</p>
			</CheckboxWrapper>
			{touched[field.name] && errors[field.name] && (
				<FormError>{errors[field.name]}</FormError>
			)}
		</Wrapper>
	);
}

Checkbox.propTypes = {
	type: PropTypes.string,
	name: PropTypes.string,
	autoComplete: PropTypes.string,
	form: PropTypes.shape({
		touched: PropTypes.object,
		errors: PropTypes.object
	}),
	disabled: PropTypes.bool,
	text: PropTypes.string,
	placeholder: PropTypes.string,
	modifiers: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};

Checkbox.defaultProps = {
	type: 'checkbox',
	name: 'agreement',
	autoComplete: 'true',
	form: { touched: {}, errors: {} },
	placeholder: '',
	disabled: false,
	text: ''
};

export default Checkbox;
